import { ShareAccessEquipmentGuideProvider } from 'app/hooks/access-sharing';
import React from 'react';
import { IEquipmentEntry } from 'types/IEquipmentEntry';
import { useAccessSharingFlowContext } from 'app/hooks/access-sharing';
import { ACCESS_SHARING_FLEET_STEPS } from 'app/constants/access-sharing';
import { CreateFleetView } from 'app/components/access-sharing/flows';

interface Props {
  equipment: IEquipmentEntry[];
  hasAtLeastOneFleet: boolean;
  onBack: () => void;
  title?: string;
  subtitle?: string;
}

export default function CreateFleetStepController({
  equipment,
  hasAtLeastOneFleet,
  onBack,
  title,
  subtitle,
}: Props) {
  const {
    stepper,
    selectedFleetName,
    selectedEquipmentIds,
    setIsFleetCreated,
    setSelectedFleetName,
    setSelectedEquipmentIds,
    setSelectedFleetId,
  } = useAccessSharingFlowContext();

  const { setStep } = stepper;

  function handlePrevStep() {
    if (hasAtLeastOneFleet) {
      setStep(ACCESS_SHARING_FLEET_STEPS.FLEET_SELECTION);
    } else {
      onBack();
    }
  }

  function handleNextStep() {
    setIsFleetCreated(true);
    setStep(ACCESS_SHARING_FLEET_STEPS.FLEET_CREATED);
  }

  return (
    <ShareAccessEquipmentGuideProvider>
      <CreateFleetView
        equipment={equipment}
        selectedFleetName={selectedFleetName}
        selectedEquipmentIds={selectedEquipmentIds}
        setSelectedFleetName={setSelectedFleetName}
        setSelectedFleetId={setSelectedFleetId}
        setSelectedEquipmentIds={setSelectedEquipmentIds}
        onBack={handlePrevStep}
        onNextStep={handleNextStep}
        title={title}
        subtitle={subtitle}
      />
    </ShareAccessEquipmentGuideProvider>
  );
}
